<script lang="ts">
	import type { Faq } from "./Faq.js";
	import FaqItem from "./FaqItem.svelte";

	const { faqs }: { faqs: Faq[] } = $props();
</script>

<div class="flex items-stretch mx-auto flex-col gap-1 xl:px-52">
	{#each faqs as { question, answer }, index (index)}
		<FaqItem {question} {answer} />
	{/each}
</div>
